import { FieldType } from '@wix/wix-data-schema-types'
import { TEXT_BOX_ROLE } from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { text, number, url } = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Text_Box',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 297,
    title: 'Connect_Panel_Title_Textbox',
    helpId: '6ae40145-3c56-4f59-bd53-408fbbf37527',
  },
  sections: [
    {
      role: TEXT_BOX_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Value_Label',
          prop: 'value',
          supportedFieldTypes: [text, number, url],
          defaultFieldType: text,
          isInputProperty: true,
        },
      ],
    },
  ],
  compactErrorPanel: true,
})
